const GridViewIcon = ({ viewBox = "0 0 16 16", className = "hayley-h-4 hayley-w-4 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M5.5 0.5H1.5C0.947715 0.5 0.5 0.947715 0.5 1.5V5.5C0.5 6.05228 0.947715 6.5 1.5 6.5H5.5C6.05228 6.5 6.5 6.05228 6.5 5.5V1.5C6.5 0.947715 6.05228 0.5 5.5 0.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 0.5H10.5C9.94772 0.5 9.5 0.947715 9.5 1.5V5.5C9.5 6.05228 9.94772 6.5 10.5 6.5H14.5C15.0523 6.5 15.5 6.05228 15.5 5.5V1.5C15.5 0.947715 15.0523 0.5 14.5 0.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.5 9.5H1.5C0.947715 9.5 0.5 9.94772 0.5 10.5V14.5C0.5 15.0523 0.947715 15.5 1.5 15.5H5.5C6.05228 15.5 6.5 15.0523 6.5 14.5V10.5C6.5 9.94772 6.05228 9.5 5.5 9.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.5 9.5H10.5C9.94772 9.5 9.5 9.94772 9.5 10.5V14.5C9.5 15.0523 9.94772 15.5 10.5 15.5H14.5C15.0523 15.5 15.5 15.0523 15.5 14.5V10.5C15.5 9.94772 15.0523 9.5 14.5 9.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default GridViewIcon;
